<template>
  <div>
    <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card max-width="100%" class="pa-0 mt-2 elevation-0" v-else>
      <v-card-text flat>
        <v-data-table
          v-if="Count == 1"
          class="elevation-1"
          dense
          :headers="headers"
          :items="viewrefItems"
          item-key="name"
          :options.sync="pagination"
          :items-per-page="itemsPerPage"
          @update:options="getreferrerFeePagination()"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{ viewrefItems.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.ref_name`]="{ item }">
            <span class="caption"
              ><b>{{ item.ref_name }}</b></span
            >
            <br />
            <span class="caption">{{ item.ref_emailid }}</span>
          </template>
          <template v-slot:[`item.paid_status`]="{ item }">
            <span class="caption red--text" v-if="item.paid_status == 0"
              >Not Paid</span
            >
            <span class="caption black--text" v-if="item.paid_status == 1"
              ><b>{{ item.fee_amt }}</b></span
            >
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <span class="caption green--text" v-if="item.status == 'Active'"
              >Active</span
            >
          </template>
          <template v-slot:[`item.corp_name`]="{ item }">
            <span class="caption"
              ><b>{{ item.corp_name }}</b></span
            >
            <br />
            <span class="caption">{{ item.email_id }}</span>
          </template>
          <template v-slot:[`item.pack_name`]="{ item }">
            <span class="caption"
              ><b>{{ item.pack_name }}</b></span
            >
            <br />
            <span class="caption">{{ item.pack_code }}</span>
          </template>
          <template v-slot:[`item.quantity`]="{ item }">
            <span class="caption"
              ><b>{{ item.quantity }}</b> card(s)</span
            >
            <br />
            <span class="caption">{{ item.annual_fee }} MYR</span>
          </template>

          <template v-slot:[`item.corp_balance`]="{ item }">
            <span class="caption">{{ item.corp_balance }}</span></template
          >
          <template v-slot:[`item.subs_start_date`]="{ item }">
            <span class="caption">{{ item.subs_start_date }}</span></template
          >

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  color="primary"
                  @click="refferedcorpdeatils(item)"
                  >mdi-eye</v-icon
                >
              </template>
              <span>Commission details</span>
            </v-tooltip>
          </template>
          <template v-slot:top>
            <v-card elevation="4" class="mb-6">
              <v-expansion-panels v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-header>Filters</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mt-n3">
                      <v-col lg="3">
                        <label class="caption">From</label>
                        <v-dialog
                          ref="dialogStart"
                          v-model="modalStart"
                          :return-value.sync="start_date"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              solo
                              elevation-5
                              class="mt-1"
                              color="primary"
                              dense
                              v-model="start_date"
                              placeholder="From"
                              append-icon="mdi-calendar"
                              readonly
                              v-on="on"
                              @click:append="date ? getcal() : getcal()"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="start_date"
                            scrollable
                            :max="end_date"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modalStart = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialogStart.save(start_date)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                      <v-col lg="3">
                        <label class="caption">To</label>
                        <v-dialog
                          ref="dialogEnd"
                          v-model="modalEnd"
                          :return-value.sync="end_date"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              solo
                              elevation-5
                              class="mt-1"
                              color="primary"
                              dense
                              v-model="end_date"
                              placeholder="To"
                              append-icon="mdi-calendar"
                              readonly
                              v-on="on"
                              @click:append="date ? getcal2() : getcal2()"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="end_date"
                            scrollable
                            :min="start_date"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modalEnd = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialogEnd.save(end_date)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>

                      <!-- <v-col cols="12" sm="12" md="3" xl="3" lg="3">
                        <label class="caption">Search Option</label>
                        <v-select
                          v-model="selectedParameter"
                          :items="selectedParameterList"
                          dense
                          solo
                          elevation-5
                          label="Search Option"
                          item-text="text"
                          item-value="value"
                          @change="hintSelection()"
                          class="mt-1"
                        ></v-select>
                      </v-col> -->
                      <v-col
                        cols="12"
                        sm="12"
                        md="2"
                        xl="2"
                        lg="2"
                        class="mt-6"
                      >
                        <v-text-field
                          v-model="search"
                          dense
                          solo
                          elevation-5
                          persistent-hint
                          label="Search"
                        ></v-text-field>
                      </v-col>
                      <v-col lg="1" class="mt-6">
                        <v-btn
                          small
                          fab
                          dark
                          color="primary"
                          @click="getreferrerFee()"
                          class="elevation-0"
                        >
                          <v-icon dark>mdi-filter</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog persistent v-model="addcommission" max-width="500">
      <v-card class="elevation-4">
        <v-toolbar dark color="header" class="elevation-0" dense>
          <v-icon>mdi-sack-percent</v-icon>

          <span class="ml-3">Commission Details - {{ CorpName }}</span>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="addcommissionclose()">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-2">
          <v-card height="auto" class="mb-4 mt-6" rounded="xl">
            <v-row>
              <v-col cols="12" md="6" lg="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Corporate</b>
                    </span>
                    <br />

                    <span class="caption black--text" v-if="CorpName != ''">
                      {{ CorpName }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Subscribed Pack</b>
                    </span>
                    <br />

                    <span class="caption black--text" v-if="PackName != ''">
                      {{ PackName }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Pack Start Date</b>
                    </span>
                    <br />

                    <span
                      class="caption black--text"
                      v-if="subsstartdate != ''"
                    >
                      {{ subsstartdate }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Quantity</b>
                    </span>
                    <br />

                    <span class="caption black--text" v-if="Quantity != ''">
                      {{ Quantity }} card(s)
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Commission Paid</b>
                    </span>
                    <br />

                    <span
                      class="caption black--text"
                      v-if="feeamt != '' && PaidStatus == 1"
                    >
                      {{ feeamt }} MYR
                    </span>
                    <span
                      class="caption red--text"
                      v-if="feeamt != '' && PaidStatus == 0"
                    >
                      Not Paid
                    </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Annual Fee</b>
                    </span>
                    <br />

                    <span class="caption black--text" v-if="Annualfee != ''">
                      {{ Annualfee }} MYR
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Pack Expiry Date</b>
                    </span>
                    <br />

                    <span class="caption black--text" v-if="subsenddate != ''">
                      {{ subsenddate }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3" v-if="PaidStatus == 1">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Remarks</b>
                    </span>
                    <br />
                    <span class="caption black--text" v-if="remarks != ''">
                      {{ remarks }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    Count: 1,

    selectedParameterList: [
      {
        text: "Mobile Number",
        value: "2",
      },
      {
        text: "Name",
        value: "1",
      },
    ],
    // searchHint: "9-10 digits",
    PackName: "",
    SubsOn: "",
    Quantity: "",
    CorpName: "",
    Annualfee: "",
    selectedParameter: "2",
    itemsPerPage: 15,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    viewDetailStatus: false,
    docStatusList: [],
    start_date: null,
    modalStart: "",
    end_date: null,
    modalEnd: "",
    docStatus: "",
    search: "",
    panel: 0,
    overlay: false,
    addedcommission: "0.00",
    empStatus: false,
    corpList: ["Mobil80 Solutions and Services", "Dwise Solutions"],
    deviceTypeList: ["All", "Android", "iOS"],
    userStatusFilter: "1",
    statusItems: [
      {
        statusName: "All",
        StatusId: "0",
      },
      {
        statusName: "Active",
        StatusId: "1",
      },
      {
        statusName: "Pending",
        StatusId: "3",
      },
      {
        statusName: "Rejected",
        StatusId: "2",
      },
    ],

    headers: [
      {
        text: "Sl No",
        align: "start",
        sortable: false,
        value: "sl_no",
      },

      //   {
      //     text: "Referrer",
      //     // align: "start",
      //     sortable: false,
      //     value: "ref_name",
      //   },

      {
        text: "Corp Name",
        value: "corp_name",
        align: "start",

        sortable: false,
      },

      {
        text: "Subscribed Pack / ID",
        value: "pack_name",
        align: "start",
        sortable: false,
      },
      {
        text: "Subscribed On",
        value: "subs_start_date",
        align: "start",
        sortable: false,
      },
      {
        text: "Qty / Annual Fee",
        value: "quantity",
        align: "start",
        sortable: false,
      },

      {
        text: "Pack Status",
        value: "status",
        align: "start",
        sortable: false,
      },
      {
        text: "Commission Paid (MYR)",
        value: "paid_status",
        align: "center",
        sortable: false,
      },
      {
        text: "Action",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    headers2: [
      {
        text: "SL NO",
        align: "start",
        sortable: false,
        value: "sl_no",
        width: "100px",
      },

      {
        text: "REFERRED CORPORATE",
        // align: "start",
        sortable: false,
        value: "",
        width: "150px",
      },

      {
        text: "CORPORATE DISPLAY ID",
        value: "",
        align: "start",
        width: "150px",
        sortable: false,
      },

      {
        text: "SUBSCRIPTION AND COMMISSION",
        value: "actions",
        align: "center",
        sortable: false,
        width: "100px",
      },
    ],
    viewrefItems: [],
    viewReferrerDetailsArray: {},
    checkaccessdata: {},
    registered_address: {},
    business_address: {},

    bankitems: [],
    fileList: [],
    CompType: "",
    addcommission: false,
    PaidStatus: "",
    feeamt: "",
    corpid: "",
    subsid: "",
    refid: "",
    subs_on: "",
    RefList: [],
    referrer: "0",
    subsenddate: "",
    subsstartdate: "",
    remarks: "",
  }),

  created() {
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");

    this.end_date = moment().format("YYYY-MM-DD");
    this.getreferrerFee();
  },
  methods: {
    hintSelection() {
      switch (this.selectedParameter) {
        case "1":
          this.search = "";
          this.searchHint = "9-10 digits";
          this.maxlength = "10";
          break;
        case "2":
          this.search = "";
          this.searchHint = "Enter Name";
          this.maxlength = "";
          break;
      }
    },
    async getreferrerFeePagination() {
      if (this.viewrefItems.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;
        var inputData = {
          method_name: "REFSERVICE",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "COMDETAILS",
            search_text: this.search,
            from_date: this.start_date,
            to_date: this.end_date,
            ref_id: this.$store.getters.get_getRefDetails.user_id,
          },
        };

        var responseData = await apiCall(inputData);

        this.viewrefItems = this.viewrefItems.concat(responseData.data.data);
      }
    },
    async getreferrerFee() {
      var inputData = {
        method_name: "REFSERVICE",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "CPORTAL",
        method_param: {
          action: "COMDETAILS",
          search_text: this.search,
          from_date: this.start_date,
          to_date: this.end_date,
          ref_id: this.$store.getters.get_getRefDetails.user_id,
        },
      };
      this.overlay = false;
      var responseData = await apiCall(inputData);
      this.viewrefItems =
        responseData.data.data == null || responseData.data.data == ""
          ? []
          : responseData.data.data;
      this.totalCount = responseData.data.data[0].total_count;
    },

    async checkaccess() {
      var inputData = {
        method_name: "ADMINUSERS",
        page_no: null,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "CHECKACESS",
          user_id: this.$store.getters.get_UserDetails.user_id,
          module_code: "CORPS",
          module_type: "1",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data[0];

      if (this.checkaccessdata.is_viewer == true) {
        this.viewreferrer(this.userStatusFilter);
      }
    },

    refferedcorpdeatils(item) {
      // console.log(item);
      // this.Count = 2;

      this.PackName = item.pack_name;
      this.Annualfee = item.annual_fee;
      this.Quantity = item.quantity;
      this.CorpName = item.corp_name;
      this.PaidStatus = item.paid_status;
      this.feeamt = item.fee_amt;
      this.corpid = item.corp_id;
      this.subsid = item.subs_id;
      this.refid = item.ref_id;
      // this.subs_on = item.subs_start_date;
      this.subsenddate = item.subs_end_date;
      this.subsstartdate = item.subs_start_date;
      this.remarks = item.remarks;
      this.addcommission = true;
    },
    addcommissionclose() {
      this.addcommission = false;
      this.remarks = "";
    },
  },
};
</script>
